/**
 * A type-guard function which can be used to check if a value is an object.
 * The type-guard will not fully narrow any unions which contain Arrays - Array<any> | Record<string, any> would result in the same type after the type-guard.
 */
export function isPlainObject<T = any>(value: any): value is Record<string, T> {
    return value !== null && typeof value === "object" && !Array.isArray(value);
}
